import { NgModule } from '@angular/core'
import { FaqQuestionComponent } from './faq-question/faq-question.component'
import { SvgModule } from 'src/app/shared/svg/svg.module'
import { FloSanitizeHtmlPipeModule } from 'src/app/libs/_pipes/sanitize-html/sanitize-html.pipe.module'
import { CommonModule } from '@angular/common'
import { SharedModule } from 'src/app/shared/shared.module'
import { FaqSectionComponent } from './faq-section/faq-section.component'

@NgModule({
  imports: [CommonModule, SharedModule, SvgModule, FloSanitizeHtmlPipeModule],
  declarations: [FaqQuestionComponent, FaqSectionComponent],
  exports: [FaqQuestionComponent, FaqSectionComponent]
})
export class FaqModule {}
